module.exports = __webpack_public_path__ + "fonts/Inter-900-greek-ext80.318d4ba.woff2";